(function () {
    "use strict";

    document.addEventListener("DOMContentLoaded", function() {
        let button = document.getElementById("elg-test-btn");
        if (button) {
            let url = button.getAttribute("data-url");

            button.addEventListener("click", function () {
                window.location.href = url;
            });
        }
    });

    document.querySelectorAll(".msh-timer-th").forEach(makeTimer);

    (function addElementsBbcodeLink() {

        document.querySelectorAll(".edito-content").forEach(
            function (edito) {
                const {oeventCategory, oeventAction} = edito.dataset;

                edito.querySelectorAll("a").forEach(
                    function (link) {
                        link.className = '';
                        link.classList.add("ob1-link-arrow", "ob1-link-reverse");
                        const hrefAttr = link.getAttribute("href");
                        link.dataset.oeventCategory = oeventCategory;
                        link.dataset.oeventAction = oeventAction;
                        if (hrefAttr.startsWith("#")) {
                            link.target = "_self";
                            link.dataset.bsToggle = "modal";
                            link.dataset.oeventLabel = hrefAttr.slice(1);
                        } else {
                            link.target = "_blank";
                            link.dataset.oeventLabel = hrefAttr;
                        }
                    }
                );
            }
        );
    }());
}());
